const formatInvoiceItems = invoiceItems => {
  let str = "";
  let items = [];
  let description = "";
  for(let item of invoiceItems){
    description = "";
    if(!(item.name.length == 0 && item.amount.length == 0)){
      description = item.description || "";
      items.push(`{ itemName: "${item.name[0]}", amount: ${item.amount}, description: ${JSON.stringify(description)} }`);
    }
  }
  if (items.length > 0){
    str = items.join(",");
  }
  return str;
}

const formatInvoices = invoices => {
  let str = "";
  let invoices_str = [];
  for(let invoice of invoices){
    invoices_str.push(`
      {
        tenantId: ${JSON.stringify(invoice.tenantId)}, 
        status: "${invoice.status}",
        invoiceItems:[${formatInvoiceItems(invoice.invoiceItems)}], 
        description: ${JSON.stringify(invoice.description)}, 
        invoiceDate: "${invoice.invoiceDate}"
      }
    `)
  }
  if (invoices_str.length > 0){
    str = invoices_str.join(", ")
  }
  return str;
}

export const getInvoicesQuery = (params) => {
    let defaultParams = {
      tenantIds:[], propertyIds:[], unitIds:[], 
      startDate: null, endDate: null, status:[],invoiceItem:"", 
      searchText:"", offset:""
    };
    let combinedParams = {...defaultParams, ...params};
    const { tenantIds, propertyIds, unitIds, startDate, endDate, status, invoiceItem, searchText, offset } = combinedParams;
    const query = `
      query{
        invoices(
          tenantIds: ${JSON.stringify(tenantIds)},
          propertyIds: ${JSON.stringify(propertyIds)},
          unitIds: ${JSON.stringify(unitIds)},
          startDate: ${ !startDate? JSON.stringify("") : JSON.stringify(startDate.format("YYYY-MM-DD"))},
          endDate: ${ !endDate? JSON.stringify("") : JSON.stringify(endDate.format("YYYY-MM-DD"))},
          status: ${JSON.stringify(status)},
          invoiceItem: ${JSON.stringify(invoiceItem)},
          searchText: ${JSON.stringify(searchText)},
          offset:${JSON.stringify(offset)},
          limit:50
        ){
          invoices{
            id
            tenantDetails{
                tenantId
                firstName
                lastName
                unitId
                propertyId
                archived
            }
            amount
            combineWithOtherInvoices
            invoiceItem
            description
            paid
            createdTs
            invoiceItems{
              itemName
              amount
              description
              autoDescription
            }
            invoiceDate
            status
            lastUpdated
            createdBy{
                id
            }
            message{
              id
              message
            }
          },
          next,
          previous,
          summary{
            header,
            body,
            footer
          }
        }
      }
    `;
    return query; 
}

export const getSingleInvoiceQuery = (invoiceId) => {
  const query = `
  query{
    invoice(id:${JSON.stringify(invoiceId)}){
      id
      tenantDetails{
        tenantId
        firstName
        lastName
        unitId
        propertyId
        archived
      }
      amount
      combineWithOtherInvoices
      invoiceItem
      description
      paid
      createdTs
      invoiceDate
      status
      lastUpdated
      invoiceItems{
        itemName
        amount
        description
        autoDescription
      }
      createdBy{
          id
      }
      message{
        id
        message
      }
    }
  }
  `;
  return query
}

export const addInvoiceMutation = (tenantId, invoiceItems, description, status, invoiceDate, 
  combineWithOtherInvoices
) => {

  const mutation = `
    mutation{
        addInvoice(tenantId: ${JSON.stringify(tenantId)}, status: "${status}",
            description:${JSON.stringify(description)}, 
            invoiceItems: [${formatInvoiceItems(invoiceItems)}],
            invoiceDate:"${invoiceDate}",
            combineWithOtherInvoices: ${combineWithOtherInvoices}
          ){
          errorMessage
          invoice{
            tenantDetails{
              tenantId
              firstName
              lastName
              unitId
              propertyId
              archived
              accountBalance
            }
            id
            amount
            combineWithOtherInvoices
            createdTs
            description
            invoiceItem
            invoiceDate
            status
            paid
            invoiceItems{
              itemName
              amount
              description
              autoDescription
            }
            createdBy{
              id
            }
            message{
              id
              message
            }
          } 
        }
      }`;
    return mutation; 
    
}

// property id is an int
export const createPropertyInvoicesMutation = (propertyIds) => {
  const mutation = `
  mutation{
    createPropertyInvoices(propertyIds:${JSON.stringify(propertyIds)}){
      previouslyCreatedMonthInvoices{
        id
        tenantDetails{
            tenantId
            firstName
            lastName
            unitId
            propertyId
            archived
        }
        amount
        combineWithOtherInvoices
        invoiceItem
        description
        paid
        createdTs
        invoiceDate
        status
        lastUpdated
        invoiceItems{
          itemName
          amount
          description
          autoDescription
        }
        createdBy{
            id
        }
        message{
          id
          message
        }
      }
      newlyCreatedMonthInvoices{
        id
        tenantDetails{
            tenantId
            firstName
            lastName
            unitId
            propertyId
            archived
        }
        amount
        invoiceItem
        description
        paid
        createdTs
        invoiceDate
        status
        lastUpdated
        createdBy{
            id
        }
        message{
          id
          message
        }
        invoiceItems{
          itemName
          amount
          description
        }
      }
      
      errorMessage
    }
  }
  `;
      return mutation;
  }

  export const createRecurringBillsInvoicesMutation = (propertyIds, tenantIds, unitIds) => {
    const mutation = `
    mutation{
      createOtherRecurringBillsInvoices(propertyIds:${JSON.stringify(propertyIds)}, tenantIds:${JSON.stringify(tenantIds)}, unitIds: ${JSON.stringify(unitIds)}){
        previouslyCreatedMonthInvoices{
          id
          tenantDetails{
              tenantId
              firstName
              lastName
              unitId
              propertyId
              archived
          }
          amount
          combineWithOtherInvoices
          invoiceItem
          description
          paid
          createdTs
          invoiceDate
          status
          lastUpdated
          invoiceItems{
            itemName
            amount
            description
            autoDescription
          }
          createdBy{
              id
          }
          message{
            id
            message
          }
        }
        newlyCreatedMonthInvoices{
          id
          tenantDetails{
              tenantId
              firstName
              lastName
              unitId
              propertyId
              archived
          }
          amount
          invoiceItem
          description
          paid
          createdTs
          invoiceDate
          status
          lastUpdated
          createdBy{
              id
          }
          message{
            id
            message
          }
          invoiceItems{
            itemName
            amount
            description
            autoDescription
          }
        }
        
        errorMessage
      }
    }
    `;
        return mutation;
    }

export const updateInvoiceMutation = (invoiceId, 
  params={tenantId: "", description: "", status:"", 
  invoiceDate:"", invoiceItems: []
}) => {
    const { tenantId, invoiceItems, description, status, invoiceDate } = params;
    const mutation = `
        mutation{
        updateInvoice(
          invoiceId: ${JSON.stringify(invoiceId)}, tenantId: ${JSON.stringify(tenantId)},
          status:"${status}", 
          description:${JSON.stringify(description)}, 
          invoiceDate:"${invoiceDate}",
          invoiceItems: [${formatInvoiceItems(invoiceItems)}],
        ){
            errorMessage
            invoice{
            id
            amount
            combineWithOtherInvoices
            createdTs
            description
            invoiceItem
            invoiceDate
            status
            paid
            invoiceItems{
              itemName
              amount
              description
              autoDescription
            }
            tenantDetails{
              tenantId
              firstName
              lastName
              unitId
              propertyId
              archived
              accountBalance
            }
            createdBy{
              id
            }
            message{
              id
              message
            }
          } 
        }
      } 
    `;
    return mutation;
}

export const deleteInvoicesMutation = (invoiceIds) => {
  const mutation = `
      mutation{
          deleteInvoice(invoiceIds: ${JSON.stringify(invoiceIds)}){
          errorMessage
          success
      }
      }
  `;
  return mutation;
}


export const bulkAddInvoicesMutation = (invoices) => {

  const mutation = `
    mutation{
      bulkAddInvoices(invoices: [
        ${formatInvoices(invoices)}
      ]){
          errorMessage
          invoices{
            tenantDetails{
              tenantId
              firstName
              lastName
              unitId
              propertyId
              archived
              accountBalance
            }
            id
            amount
            combineWithOtherInvoices
            createdTs
            description
            invoiceItem
            invoiceDate
            status
            paid
            invoiceItems{
              itemName
              amount
              description
              autoDescription
            }
            createdBy{
              id
            }
            message{
              id
              message
            }
          } 
        }
      }`;
    return mutation; 
}

const formatInvoiceInputItems = invoiceItems => {
  if (!invoiceItems || !Array.isArray(invoiceItems)) return "";
  return invoiceItems.map(item => `{
    name: ${JSON.stringify(Array.isArray(item.name) ? item.name[0] : item.name)},
    amount: ${Number(item.amount)},
    isValid: ${item.isValid === true}
  }`).join(',');
}

const formatInvoiceInputs = invoiceInputs => {
  if (!invoiceInputs || !Array.isArray(invoiceInputs)) return "";
  return invoiceInputs.map(inv => `{
    tenantId: ${JSON.stringify(inv.tenantId)},
    invoiceDate: ${JSON.stringify(inv.invoiceDate)},
    invoiceItems: [${formatInvoiceInputItems(inv.invoiceItems)}]
  }`).join(',');
}

export const calculateBulkInvoicesMutation = (propertyIds, invoiceDate, invoiceItems) => {
  const mutation = `
    mutation{
      calculateBulkInvoices(propertyIds:${JSON.stringify(propertyIds)}, invoiceDate:${JSON.stringify(invoiceDate)}, invoiceItems:${JSON.stringify(invoiceItems)}){
        message
        success
        calculatedInvoices{
          tenantId
          tenantName
          invoiceDate
          propertyId
          propertyName
          unitName
          invoiceItems{
            name
            amount
            alreadyExists
            errors
            warnings
            isValid
          }
        }
      }
    }
  `;
  return mutation;
}

export const createBulkInvoicesMutation = (invoiceInputs) => {
  const body = formatInvoiceInputs(invoiceInputs);
  const mutation = `
    mutation{
      createBulkInvoices(invoiceInputs: [${body}]){
        message
        success
        invoices{
          tenantDetails{
            tenantId
            firstName
            lastName
            unitId
            propertyId
            archived
          }
          id
          amount
          invoiceItem
          description
          invoiceDate
          invoiceItems{
            itemName
            amount
            description
          }
          status
          paid
          createdTs
          lastUpdated
          createdBy{ id }
          message{ id message }
        }
      }
    }
  `;
  return mutation;
}